import fr from 'facet-rest';
import MeetingHeldStatusPicklist from 'Components/UI/MeetingHeldStatusPicklist';
import EditMeetingDateField from 'Components/UI/EditMeetingDateField';
import SelectField from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';

export const EditMeetingModalOverride = fr.metaOverride()
  .nameOverride('startTime', {
    readonly: false, // NOTE: field is readonly, but must be set to true, so we can override readonly component
    _component: () => EditMeetingDateField,
  })
  .nameOverride('meetingType', {
    _component: () => SelectField,
  })
  .nameOverride('meetingHeldStatus', {
    _component: () => MeetingHeldStatusPicklist,
  })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  });
